module.exports = __webpack_public_path__ + "img/lazada-h.c5750b77.png";